import { getCurrentUser } from '@bridebook/toolbox/src/api/auth/getCurrentUser';
import type { AgentState } from '../store/agent-store';
import type { LoopState } from '../store/loop-store';

// The coach's server-side state for the signed-in couple. The `*Readable` flags tell a
// store that failed to read from a couple who has said nothing.
export type PlannerServerState = {
  weddingId: string;
  loop?: LoopState;
  loopReadable: boolean;
  memory?: AgentState;
  memoryReadable: boolean;
};

/**
 * Reads what the coach remembers, for the console or an eval check. Bound to
 * `__aiPlannerDebugState()` in the browser. Null means the request failed, not that the
 * store is empty.
 */
export const readPlannerServerState = async (): Promise<PlannerServerState | null> => {
  const currentUser = await getCurrentUser();
  const token = currentUser ? await currentUser.getIdToken() : null;
  const response = await fetch('/api/ai-planner/debug-state', {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!response.ok) return null;
  return (await response.json()) as PlannerServerState;
};
